import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

interface MovieRowProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  moreLink?: string;
  moreLabel?: string;
  columns?: "five" | "four";
}

export default function MovieRow({
  title,
  subtitle,
  movies,
  moreLink,
  moreLabel = "查看全部",
  columns = "five",
}: MovieRowProps) {
  const gridClass =
    columns === "five"
      ? "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5"
      : "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5";

  return (
    <section className="w-full px-4 md:px-6 pt-12 md:pt-16">
      <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
        {moreLink && (
          <Link
            to={moreLink}
            className="inline-flex items-center gap-1 shrink-0 text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
          >
            {moreLabel}
            <i className="ri-arrow-right-line" />
          </Link>
        )}
      </div>
      <div className={gridClass}>
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}